export function objectToHash<T extends object>(obj: T) {
    return btoa(encodeURIComponent(JSON.stringify(obj)));
}

export function hashToObject<T extends string>(hash: T) {
    return JSON.parse(decodeURIComponent(atob(hash)));
}
